import React, { Component } from "react";
import { connect } from "react-redux";
import {
  clearNotifications,
  getNotifications,
  loadNotifications,
  loadNotificationsCount,
  markNotifications,
} from "../../actions/users";
import moment from "moment";
import { Link } from "react-router";
import { push } from "redux-router";
import { toast } from "react-toastify";

const defaultParams = {
  page: 1,
  per_page: 15,
  search: "",
  selected: [],
};

const NOTIFICATONS = {
  webinarStarts: "webinar_starts",
  webinarDayReminder: "webinar_day_reminder",
  newOnlineWebinar: "new_online_webinar",
  webinarHourReminder: "webinar_hour_reminder",
  webinarRecorded: "webinar_recorded",
  newRecordedWebinar: "new_recorded_webinar",
  webinarGranted: "webinar_granted",
  newGroupMaterial: "new_group_material",
};

const reminders = [
  NOTIFICATONS.webinarDayReminder,
  NOTIFICATONS.webinarHourReminder,
];

const recorded = [
  NOTIFICATONS.webinarRecorded,
  NOTIFICATONS.newRecordedWebinar,
];

class NotificationsPage extends Component {
  constructor(props) {
    super(props);

    this.state = defaultParams;
  }

  componentDidMount() {
    this.getNotifications();
  }

  componentWillUnmount() {
    this.props.clearNotifications();
  }

  getNotifications = () => {
    this.props.getNotifications(this.state);
  };

  loadNotifications = () => {
    this.props.loadNotifications(this.state);
  };

  handleLoadMore = () =>
    this.setState({ page: this.state.page + 1 }, this.loadNotifications);

  handleQueryChange = (search, timeout = 500) => {
    this.setState({ ...defaultParams, search }, () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => this.getNotifications(), timeout);
    });
  };

  handleSelect = (id) => {
    this.setState((state) =>
      state.selected.includes(id)
        ? { selected: state.selected.filter((s) => s !== id) }
        : { selected: [...state.selected, id] }
    );
  };

  handleMark = () =>
    this.state.selected &&
    this.props.markNotifications({
      ids: this.state.selected,
      callback: () => {
        this.setState(defaultParams);
        this.props.getNotifications(this.state);
        this.props.getNotificationCount();
        toast.success("Notifications have been successfully marked as read");
      },
    });

  handleMarkNotification = (id) =>
    this.props.markNotifications({
      ids: [id],
      callback: () => {
        this.props.getNotificationCount();
      },
    });

  handleNavigate = (link) => this.props.navigate(link);

  render() {
    const { notifications } = this.props;

    const { search, page } = this.state;

    const count = notifications ? notifications.count : 0;
    const totalPages = notifications ? notifications.totalPages : 0;
    const data = notifications ? notifications.data : [];

    return (
      <main className="site--width">
        <div className="notifications-page">
          <h5>Notifications({count})</h5>
          {!data.length && (
            <p className="group-no-webinars">No notifications</p>
          )}
          {!!data.length && (
            <div>
              {/* <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div className="container_admin_user">
                  <div className="search_admin">
                    <input id="search" type="submit" className="validate" />
                    <label htmlFor="search">
                      <i className="material-icons icon_search">search</i>
                    </label>
                    <input
                      type="search"
                      placeholder="Search"
                      value={search}
                      onChange={(e) => this.handleQueryChange(e.target.value)}
                    />
                    <i
                      className="material-icons icon_close"
                      onClick={() => this.handleQueryChange("")}
                    >
                      close
                    </i>
                  </div>
                </div>
                <a
                  style={{ padding: "10px", textAlign: "center" }}
                  className="button_classic"
                  onClick={this.handleMark}
                >
                  Mark as read
                </a>
              </div> */}
              <div className="notification-list">
                {data.map((n) => (
                  <Notification
                    {...n}
                    key={n.id}
                    handleSelect={this.handleSelect}
                    selected={this.state.selected.includes(n.id)}
                    handleMarkNotification={this.handleMarkNotification}
                    handleNavigate={this.handleNavigate}
                  />
                ))}
              </div>
              {page < totalPages && (
                <a className="more_item" onClick={this.handleLoadMore}>
                  Load more
                </a>
              )}
            </div>
          )}
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  notifications: state.users.notifications,
});

const mapDispatchToProps = (dispatch) => ({
  loadNotifications: (payload) => dispatch(loadNotifications(payload)),
  getNotifications: (payload) => dispatch(getNotifications(payload)),
  clearNotifications: () => dispatch(clearNotifications()),
  markNotifications: (payload) => dispatch(markNotifications(payload)),
  navigate: (link) => dispatch(push(link)),
  getNotificationCount: () => dispatch(loadNotificationsCount()),
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsPage);

export class Notification extends React.Component {
  componentDidMount() {
    if (!this.props.is_read) this.props.handleMarkNotification(this.props.id);
  }

  render() {
    const {
      notification_date,
      body,
      notification_type,
      group_id,
      notifiable_id,
      group_title,
      is_read,
      handleSelect,
      selected,
      id,
      handleMarkNotification,
      handleNavigate,
    } = this.props;

    const date = moment(notification_date).format("DD/MM/YYYY h:mm A");

    const canClick = !reminders.includes(notification_type);

    let link = "";

    if (recorded.includes(notification_type)) {
      link = `/groups/${group_id}/webinars/${notifiable_id}`;
    }

    if (notification_type === NOTIFICATONS.webinarStarts) {
      link = `/groups/${group_id}/webinars/current`;
    }
    if (notification_type === NOTIFICATONS.newOnlineWebinar) {
      link = `/groups/${group_id}/webinars/upcoming`;
    }

    return (
      <div className="notification-wrapper">
        {/* <p>
          <input
            type="checkbox"
            className="filled-in"
            id="filled-in-box10"
            checked={selected}
            key={id}
            disabled={is_read}
          />
          <label for="filled-in-box10" onClick={() => handleSelect(id)}></label>
        </p> */}
        <div
          className="notification"
          style={{ cursor: canClick ? "pointer" : "auto" }}
          onClick={() => canClick && handleNavigate(link)}
        >
          {/* <div
            className="notification-status"
            style={{ backgroundColor: is_read ? "green" : "red" }}
          /> */}
          <div
            className="notification-content"
            style={{ fontWeight: !is_read ? "bold" : "normal" }}
          >
            <div>{body}</div>
            <div className="notification-date">
              <div>{group_title}</div>
              <div>{date}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/NotificationsPage/index.jsx